import { combineReducers } from 'redux';

export default () => combineReducers({});

// export default {};
